import { IExtendedTab } from "components/ExtendedTabs/ExtendedTabs.types";
import { ModelCompareTab } from "../GettingStartedWithUniFi.types";
import { IHeroSection } from "../_components/DesktopHeroSimple/DesktopHeroSimple.types";

import SwitchingImage from "../assets/tabs/compare/aggregation.png";

import MassiveScaleHeroVideo from "../assets/tour/massive-scale/massive-scale.mp4";
import MassiveScaleHeroPoster from "../assets/tour/massive-scale/massive-scale.jpg";

import MassiveScaleMobileHeroVideo from "../assets/tour/mobile/massive-scale/intro-1080.mp4";
import MassiveScaleMobileHeroPoster from "../assets/tour/mobile/massive-scale/intro-1080.jpg";

export const MASSIVE_SCALE_DEPLOYMENT_SWITCHING_TAB = {
  id: ModelCompareTab.Switching,
  label: "gettingStartedWithUniFi.compareTabs.switching",
  image: SwitchingImage,
} satisfies IExtendedTab;

export const DEPLOYMENT_HERO_CONFIG = {
  id: 0,
  label: "gettingStartedWithUniFi.tabs.massiveScaleDeployment",
  poster: MassiveScaleHeroPoster,
  src: MassiveScaleHeroVideo,
  showGradient: true,
} satisfies IHeroSection;

export const MASSIVE_SCALE_DEPLOYMENT_MOBILE_CONFIG = {
  id: 0,
  label: "gettingStartedWithUniFi.tabs.massiveScaleDeployment",
  poster: MassiveScaleMobileHeroPoster,
  src: MassiveScaleMobileHeroVideo,
  showGradient: true,
} satisfies IHeroSection;
